module.exports = __webpack_public_path__ + "static/media/HNTFILAlternativeCovers.beba57f8.jpg";